<template>
<div class="fullWidth fCol jStart aStart gameRow">
  <div class="fullWidth fRow jBetween aStart firstRow" v-if="indx === 0">
    <div class="idx">ردیف</div>
    <div class="gameName growFull">نام بازی</div>
    <div class="gameClassification">طبقه‌بندی بازی</div>
    <div class="gameLesson">درس</div>
    <div class="gameState fCol jCenter aCenter">
      وضعیت بازی
    </div>
    <div class="gameActions fRow jCenter aCenter">
      عملیات
    </div>
  </div>
  <div class="fullWidth fRow jBetween aCenter rel">
    <div class="idx">{{indx + 1}}</div>
    <div class="gameName growFull">{{data.name}}</div>
    <div class="gameClassification">
      <span>{{data.classificationName}}</span>
    </div>
    <div class="gameLesson">
      <span>ریاضی</span>
    </div>
    <div class="gameState fCol jCenter aCenter">
      <switch-button
        @click.native="switchStatus"
        activeLabel="فعال"
        deactiveLabel="غیرفعال"
        :val="gameStatus"/>
    </div>
    <div class="gameActions fRow jCenter aCenter">
      <i class="material-icons-round gameAction d transition-fast" @click="deleteItem">delete</i>
    </div>
    <div class="deleteModal fRow jCenter aCenter wrap" v-if="deleteModal">
      <h3 class="">آیا از حذف {{data.name}} مطمئنید؟</h3>
      <div class="b fRow jStart aCenter delete" @click="alert('delete')">
        <i class="material-icons-round">delete</i>
        <label>حذف آیتم</label>
      </div>
      <div class="b fRow jStart aCenter" @click="deleteModal = false">
        <label>بازگشت</label>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import axios from 'axios';
import errorHandler from '@/mixins/mixin';
import makeToast from '@/mixins/makeToast';
import SwitchButton from '@/components/SwitchButton.vue';
import '@/assets/new.scss';
import '@/assets/gameRowStyle.scss';

export default {
  mixins: [errorHandler, makeToast],
  props: ['data', 'indx'],
  data() {
    return {
      baseURL: this.$store.state.baseUrl,
      V: this.$store.state.apiVersion,
      gameStatus: false,
      gameLessons: [
        {
          id: 0,
          label: 'ریاضی',
        },
        {
          id: 1,
          title: 'فیزیک',
        },
        {
          id: 2,
          title: 'شیمی',
        },
        {
          id: 3,
          title: 'زیست شناسی',
        },
        {
          id: 4,
          title: 'ادبیات',
        },
        {
          id: 5,
          title: 'عربی',
        },
        {
          id: 6,
          title: 'دین و زندگی',
        },
        {
          id: 7,
          title: 'جغرافیا',
        },
        {
          id: 8,
          title: 'تاریخ',
        },
        {
          id: 9,
          title: 'فلسفه',
        },
        {
          id: 10,
          title: 'زمین شناسی',
        },
      ],
      deleteModal: false,
    };
  },
  components: {
    SwitchButton,
  },
  methods: {
    getGrades(f) {
      let reqUrl = `${this.baseURL}/api/v${this.V}/Grades`;
      if (f !== -1) {
        reqUrl = `${this.baseURL}/api/v${this.V}/Grades?field=${f}`;
      } else {
        return;
      }
      axios({
        method: 'get',
        url: reqUrl,
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
      }).then((response) => {
        if (response.data.isSuccess) {
          this.grades = [];
          const arr = response.data.data;
          this.grades.push({
            id: '',
            title: 'حذف فیلتر',
          });
          for (let i = 0; i < arr.length; i += 1) {
            this.grades.push({
              id: arr[i].id,
              title: arr[i].title,
            });
          }
          // console.warn(this.grades);
        } else {
          this.responseFalse = true;
        }
      }, (error) => {
        this.makeToast('error', this.errorHandler(error), 3000);
        // console.log(error);
      });
    },
    switchStatus() {
      this.gameStatus = !this.gameStatus;
      // request here
    },
    deleteItem() {
      this.deleteModal = true;
    },
  },
  computed: {
  },
  watch: {
  },
  mounted() {
    this.gameStatus = this.data.status;
  },
};
</script>

<style lang="scss" scoped>
</style>
